// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YPsK","right":"styles_right__DZxLh"};